export default __webpack_public_path__ + "static/media/pdf-emailing.08bbc760.pdf";